import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Layout from '../components/Layout';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import PersonAutocomplete from '../components/ui/PersonAutocomplete';
import { ArrowLeft } from 'lucide-react';

const NewTicket = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [people, setPeople] = useState([]); // diretório p/ autocomplete do solicitante
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    priority: 'Media',
    requester_name: '',
    requester_email: '',
  });

  useEffect(() => {
    api
      .get('/collaborators/listbox')
      .then((r) => setPeople(Array.isArray(r.data) ? r.data : []))
      .catch(() => setPeople([]));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/tickets/', formData);
      navigate(`/tickets/${response.data.id}`);
    } catch (error) {
      console.error('Error creating ticket:', error);
      alert('Erro ao criar chamado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="new-ticket-page">
        <div className="flex items-center space-x-4">
          <Button variant="ghost" aria-label="Voltar" onClick={() => navigate('/tickets')} data-testid="back-to-tickets-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900" data-testid="new-ticket-title">Novo Chamado</h1>
            <p className="text-gray-500">Criar um novo chamado de suporte</p>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Informações do Chamado</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Título *</label>
                <Input
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  placeholder="Resumo do problema"
                  required
                  data-testid="ticket-title-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Descrição *</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  placeholder="Descreva o problema em detalhes"
                  rows={6}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  data-testid="ticket-description-input"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Solicitante</label>
                  <PersonAutocomplete
                    people={people}
                    name={formData.requester_name}
                    onChange={({ name, email }) =>
                      setFormData((f) => ({
                        ...f,
                        requester_name: name,
                        // e-mail só é definido ao escolher alguém da lista
                        ...(email !== undefined ? { requester_email: email } : {}),
                      }))
                    }
                    data-testid="ticket-requester-name-input"
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Comece a digitar e escolha na lista — o e-mail é preenchido automaticamente.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email do Solicitante</label>
                  <Input
                    type="email"
                    value={formData.requester_email}
                    onChange={(e) => setFormData({ ...formData, requester_email: e.target.value })}
                    placeholder="email@exemplo.com"
                    data-testid="ticket-requester-email-input"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Prioridade</label>
                <select
                  value={formData.priority}
                  onChange={(e) => setFormData({ ...formData, priority: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  data-testid="ticket-priority-select"
                >
                  <option value="Baixa">Baixa</option>
                  <option value="Media">Média</option>
                  <option value="Alta">Alta</option>
                  <option value="Urgente">Urgente</option>
                </select>
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <Button type="button" variant="outline" onClick={() => navigate('/tickets')} data-testid="cancel-ticket-btn">
                  Cancelar
                </Button>
                <Button type="submit" disabled={loading} data-testid="submit-ticket-btn">
                  {loading ? 'Criando...' : 'Criar Chamado'}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default NewTicket;
